module.exports = __webpack_public_path__ + "img/vertical_7_3_7042.3fa07af7.png";